module.exports = __webpack_public_path__ + "img/guizhouHints_24.b38d3dde.jpg";